import styled from "@emotion/styled";
import { FieldInputProps } from "react-final-form";

import {
  Avatar,
  DesignToken,
  IPickerListItem,
  Picker,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Role from "constants/role";
import { agentAcceptsAutoassignment } from "helpers/agent";
import { IAgent } from "store/entities/agents";
import { withVar } from "themes/helpers";

const NOT_ACCEPTING = {
  key: "not_accepting",
  name: "Not accepting",
};

const ACCEPTING = {
  key: "accepting",
  name: "Accepting",
};

const assignmentOptions: IPickerListItem[] = [NOT_ACCEPTING, ACCEPTING];

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const MemberItem = ({ agent, input }: { agent: IAgent; input: FieldInputProps<string[]> }) => {
  const { id, permission, avatar, name, status } = agent;

  const isInactive = status === "invited";
  const isAccepting = input.value.includes(id);
  const isViewer = permission === Role.Viewer;
  const autoassignmentDisallowed = isViewer || isInactive;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSelect = (selected: IPickerListItem[] | null) => {
    if (!selected) {
      return;
    }
    const selectedKey = selected[0].key;

    if (selectedKey === ACCEPTING.key) {
      input.onChange([...input.value, id]);
    } else {
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      input.onChange(input.value.filter((oldId: any) => oldId !== id));
    }
  };

  return (
    <Flex
      key={agent.id}
      css={{
        paddingBlock: withVar(SpacingToken.Spacing3),
        borderBottom: `1px solid ${withVar(DesignToken.BorderBasicTertiary)}`,
        alignItems: "center",
        minHeight: "32px",
      }}
    >
      <Flex flexBasis="50%" gap={withVar(SpacingToken.Spacing2)} alignItems="center">
        <Avatar src={avatar ?? undefined} type={avatar ? "image" : "text"} text={name} size="xsmall" />
        <Text>{agent.name}</Text>
      </Flex>
      <FlexGrowChildren flexBasis="50%">
        {agentAcceptsAutoassignment(agent) ? (
          <Picker
            options={assignmentOptions}
            selected={[isAccepting ? ACCEPTING : NOT_ACCEPTING]}
            onSelect={handleSelect}
            size="compact"
            disabled={autoassignmentDisallowed}
            hideClearButton
            data-testid="auto-assignment-picker"
          />
        ) : (
          <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>{getContent(agent)}</Text>
        )}
      </FlexGrowChildren>
    </Flex>
  );
};

const FlexGrowChildren = styled(Flex)`
  // DS tooltip renderer is a div and doesn't grow by default
  & > div {
    flex-grow: 1;
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getContent = (agent: IAgent) => {
  if (agent.permission === Role.Viewer) {
    return "Viewers can't be auto-assigned to tickets.";
  }
  if (agent.status !== "active") {
    return "Users without an activated account can't be auto-assigned to tickets.";
  }
  return "Auto-assignment is deactivated in the agent profile.";
};
